import React, { FC, useState, useEffect, useCallback, useMemo } from 'react'

import { Grid, Button, Container, Card, Menu, Segment, List, Image, Popup } from 'semantic-ui-react'

import { themes } from '@/theme/context'
import { Winners } from '@/components/Winners'
import { CustomCardGroup, CustomImage, FlexBlock, Link } from '@/components/OtherCustomComponents/style'
import { FullWidthBackgroundContainer, ThemedText, BodySegment, BodyContainer, ListItem, TextRight, VerticalDate, Content, LeftBorderedSegment, IconsWrapper, LeftBorderedSegmentList, ScheduleCardGroup } from './style'

export const BodyComponent = (props) => {
    const { drupalHost, currentAct } = props;

    return (<BodyContainer>
        <FullWidthBackgroundContainer>
            <Container>
                <CustomCardGroup itemsPerRow={2} stackable>
                    <Card>
                        <Card.Content>
                            <FlexBlock>
                                <Image spaced="right" src="/themes/bakalavr/images/fieb6.svg" />
                                <b>Очно<br/>в&nbsp;вузе — базовой площадке</b>
                            </FlexBlock>
                            <p>Экзамен проходит в&nbsp;одно и то же время во&nbsp;всех вузах — базовых площадках с&nbsp;организацией видеотрансляции в&nbsp;сети Интернет</p>
                        </Card.Content>
                    </Card>
                    <Card>
                        <Card.Content>
                            <FlexBlock>
                                <Image spaced="right" src="/themes/bakalavr/images/fieb4.svg" />
                                <b>Дистанционно<br/>с&nbsp;применением прокторинга</b>
                            </FlexBlock>
                            <p>Экзамен с&nbsp;прокторингом предполагает  видеонаблюдение и видеозапись экрана</p>
                        </Card.Content>
                    </Card>
                </CustomCardGroup>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <p>Оценка качества подготовки обучающихся, проведенная с&nbsp;помощью сервиса «{themes[currentAct].title}», может быть определена как вид внутренней системы оценки качества образования (<Link href="/node/1668">ВСОКО</Link>) и зачтена при&nbsp;прохождении государственных аккредитационных процедур контроля.</p>
            <p><ThemedText><b>Обладатели лучших результатов ФИЭБ-2025</b></ThemedText></p>
            <Winners {...props} />
        </Container>
        <FullWidthBackgroundContainer>
            <Container>
                <p><ThemedText><b>График проведения</b></ThemedText></p>
                <ScheduleCardGroup itemsPerRow={2} centered stackable>
                    <Card>
                        <ListItem>
                            <VerticalDate>
                                1 апреля
                            </VerticalDate>
                            <Content>
                                <div><span>01.03.01</span><span>Математика</span></div>
                                <div><span>02.03.03</span><span>Математическое обеспечение и администрирование информационных систем</span></div>
                                <div><span>08.05.01</span><span>Строительство уникальных зданий и сооружений</span></div>
                                <div><span>39.03.01</span><span>Социология</span></div>
                                <div><span>43.03.01</span><span>Сервис</span></div>
                            </Content>
                        </ListItem>
                    </Card>
                    <Card>
                        <ListItem>
                            <VerticalDate>
                                15 апреля
                            </VerticalDate>
                            <Content>
                                <div><span>08.03.01</span><span>Строительство</span></div>
                                <div><span>10.05.01</span><span>Компьютерная безопасность</span></div>
                                <div><span>21.05.06</span><span>Нефтегазовая техника и технологии</span></div>
                                <div><span>38.03.02</span><span>Менеджмент</span></div>
                                <div><span>44.03.03</span><span>Специальное (дефектологическое) образование</span></div>
                            </Content>
                        </ListItem>
                    </Card>
                    <Card>
                        <ListItem>
                            <VerticalDate>
                                3 апреля
                            </VerticalDate>
                            <Content>
                                <div><span>02.03.01</span><span>Математика и компьютерные науки</span></div>
                                <div><span>13.03.01</span><span>Теплоэнергетика и теплотехника</span></div>
                                <div><span>20.03.01</span><span>Техносферная безопасность</span></div>
                                <div><span>21.03.01</span><span>Нефтегазовое дело</span></div>
                                <div><span>33.05.01</span><span>Фармация</span></div>
                                <div><span>38.03.06</span><span>Торговое дело</span></div>
                            </Content>
                        </ListItem>
                    </Card>
                    <Card>
                        <ListItem>
                            <VerticalDate>
                                17 апреля
                            </VerticalDate>
                            <Content>
                                <div><span>09.03.03</span><span>Прикладная информатика</span></div>
                                <div><span>10.05.03</span><span>Информационная безопасность автоматизированных систем</span></div>
                                <div><span>21.03.02</span><span>Землеустройство и кадастры</span></div>
                                <div><span>38.05.01</span><span>Экономическая безопасность</span></div>
                                <div><span>40.03.01</span><span>Юриспруденция</span></div>
                                <div><b><span>43.03.02</span></b><b><span>Туризм*</span></b></div>
                            </Content>
                        </ListItem>
                    </Card>
                    <Card>
                        <ListItem>
                            <VerticalDate>
                                8 апреля
                            </VerticalDate>
                            <Content>
                                <div><span>01.03.02</span><span>Прикладная математика и информатика</span></div>
                                <div><span>38.03.04</span><span>Государственное и муниципальное управление</span></div>
                                <div><span>35.03.06</span><span>Агроинженерия</span></div>
                                <div><span>42.03.01</span><span>Реклама и связи с&nbsp;общественностью</span></div>
                                <div><span>44.03.02</span><span>Психолого-педагогическое образование</span></div>
                            </Content>
                        </ListItem>
                    </Card>
                    <Card>
                        <ListItem>
                            <VerticalDate>
                                22 апреля
                            </VerticalDate>
                            <Content>
                                <div><span>09.03.01</span><span>Информатика и вычислительная техника</span></div>
                                <div><span>09.03.04</span><span>Программная инженерия</span></div>
                                <div><span>10.05.02</span><span>Информационная безопасность телекоммуникационных систем</span></div>
                                <div><span><b>35.03.04</b></span><span><b>Агрономия*</b></span></div>
                                <div><span>38.03.01</span><span>Экономика</span></div>
                            </Content>
                        </ListItem>
                    </Card>
                    <Card>
                        <ListItem>
                            <VerticalDate>
                                10 апреля
                            </VerticalDate>
                            <Content>
                                <div><span>05.03.06</span><span>Экология и природопользование</span></div>
                                <div><span>13.03.02</span><span>Электроэнергетика и электротехника</span></div>
                                <div><span><b>19.03.01</b></span><span><b>Биотехнология*</b></span></div>
                                <div><span>38.03.03</span><span>Управление персоналом</span></div>
                                <div><span>38.03.05</span><span>Бизнес-информатика</span></div>
                                <div><span>40.05.01</span><span>Правовое обеспечение национальной безопасности</span></div>
                            </Content>
                        </ListItem>
                    </Card>
                    <Card>
                        <ListItem>
                            <VerticalDate>
                                24 апреля
                            </VerticalDate>
                            <Content>
                                <div><span>09.03.02</span><span>Информационные системы и технологии</span></div>
                                <div><span>10.03.01</span><span>Информационная безопасность</span></div>
                                <div><span>15.03.02</span><span>Технологические машины и оборудование</span></div>
                                <div><span>44.03.01</span><span>Педагогическое образование</span></div>
                                <div><span>44.03.05</span><span>Педагогическое образование (с&nbsp;двумя профилями подготовки)</span></div>
                            </Content>
                        </ListItem>
                    </Card>
                </ScheduleCardGroup>
                <p>* Новые направления подготовки и специальности ФИЭБ-2025.</p>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <Segment>
                <p><ThemedText><b>Формы участия в&nbsp;ФИЭБ</b></ThemedText></p>
                <Grid stackable>
                    <Grid.Row columns={3}>
                        <Grid.Column textAlign="center" width={6}>
                            <CustomImage src="/themes/bakalavr/images/fieb2.svg" centered size="tiny" $margin="0 auto .5em"/>
                            <Link href="/node/526">Вуз — базовая площадка</Link>
                        </Grid.Column>
                        <Grid.Column textAlign="center" width={5}>
                            <CustomImage src="/themes/bakalavr/images/fieb3.svg" centered $height="47px" $margin="0 auto .5em" />
                            <Link href="/node/843">Вуз — участник</Link>
                        </Grid.Column>
                        <Grid.Column textAlign="center" width={5}>
                            <CustomImage src="/themes/bakalavr/images/fieb7.svg" centered $height="47px" $margin="0 auto .5em" />
                            <Link href="/node/567">Студент</Link>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        </Container >
        <Container>
            <p><ThemedText><b>Модель ПИМ</b></ThemedText></p>
            <p>Используемые педагогические измерительные материалы (ПИМ) сертифицированы.</p>
            <Grid stackable>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <LeftBorderedSegment>
                            <p><b>Первая часть ПИМ</b><br/>
                            <b>Полидисциплинарное тестирование</b> формируется на&nbsp;основании выбора не&nbsp;менее <b>4</b>&nbsp;из предложенного перечня <b>дисциплин</b> в&nbsp;соответствии с&nbsp;программой экзамена по&nbsp;направлению подготовки.<br/>
                            <b>40 баллов</b> – максимум за&nbsp;1 часть</p>
                        </LeftBorderedSegment>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <LeftBorderedSegment>
                            <p><b>Вторая часть ПИМ</b><br/>
                            <b>Междисциплинарные кейс-задания</b> формируются на&nbsp;основании выбора <b>3&nbsp;видов профессиональной деятельности (типов задач профессиональной деятельности)</b> в&nbsp;соответствии с&nbsp;ОПОП.<br />
                            <b>60 баллов</b> – максимум за&nbsp;2 часть</p>
                        </LeftBorderedSegment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <br/>
            <TextRight><Link href="/node/344">Подробнее</Link></TextRight>
        </Container>
        <Container>
            <p><Link href="/node/350">Алгоритм и пример оценки результатов</Link></p>
        </Container>
        <FullWidthBackgroundContainer>
            <Container>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <p><ThemedText><b>Сертификаты качества и свидетельство</b></ThemedText></p>
                            <p>Образовательным организациям по&nbsp;итогам успешного прохождения независимой оценки качества образования предоставляются сертификаты качества.</p>
                        </Grid.Column>
                        <Grid.Column width={5} verticalAlign='middle'>
                            <IconsWrapper>
                                <Popup
                                    content={<>Учитываются в&nbsp;проекте <Link target="_blank" href="//expert-edu.ru/services/proekt-luchshie-obrazovatelnye-programmy-innovatsionnoj-rossii.html">«Лучшие образовательные программы инновационной России»</Link></>}
                                    trigger={<Image src="/themes/fepo/images/fepo2.png" floated="left" size='tiny' />}
                                    hideOnScroll={true}
                                    style={{ fontSize: '18px' }}
                                    hoverable={true}
                                />
                                <Popup
                                    content={<>Учитываются в&nbsp;<Link target="_blank" href="//best-edu.ru/ratings/national/rejting-ocenka-kachestva-obrazovaniya">Национальном агрегированном рейтинге</Link></>}
                                    trigger={<Image src="/themes/fepo/images/fepo13.png" floated="right" size='tiny' />}
                                    hideOnScroll={true}
                                    style={{ fontSize: '18px' }}
                                    size="huge"
                                    wide={true}
                                    hoverable={true}
                                />
                                <Popup
                                    content={<>Учитываются при&nbsp;процедуре профессионально-общественной аккредитации</>}
                                trigger={<CustomImage src="/themes/fepo/images/fepo14.png?new" centered size='tiny' $margin='50px auto auto auto' />}
                                    hideOnScroll={true}
                                    style={{ fontSize: '18px' }}
                                    hoverable={true}
                                />
                            </IconsWrapper>
                        </Grid.Column>
                        <Grid.Column width={3} verticalAlign='middle'>
                            <Image centered src='/themes/bakalavr/images/fieb12.png?1' />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid>
                    <Grid.Row><Grid.Column>Критерии для включения направления подготовки и специальности ВО в сертификат качества</Grid.Column></Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <LeftBorderedSegmentList>суммарное количество именных золотых, серебряных, бронзовых сертификатов по&nbsp;направлению подготовки составляет <b>не&nbsp;менее 50%</b> от&nbsp;общего числа именных сертификатов для&nbsp;данного направления подготовки в&nbsp;вузе</LeftBorderedSegmentList>
                            <LeftBorderedSegmentList>выборка студентов по&nbsp;направлению подготовки составляет <b>не&nbsp;менее 10 человек</b></LeftBorderedSegmentList>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <br/>
                <p>По&nbsp;итогам ФИЭБ вузу и студентам предоставляется <b>доступ к&nbsp;именным сертификатам</b> с&nbsp;указанием набранных баллов (процентов).<br/>
                Категории именных сертификатов студентов определяются на&nbsp;основании рейтинга <b>всех результатов</b> студентов конкретного направления подготовки по&nbsp;проценту набранных баллов.</p>
                <Grid stackable>
                    <Grid.Row columns={4}>
                        <Grid.Column textAlign="center">
                            <CustomImage src="/themes/bakalavr/images/fieb8.jpg?1" centered size="tiny" $margin="0 auto .5em" />
                            золотые<br/> (<b>первые 10&nbsp;% студентов</b> в&nbsp;рейтинге)
                        </Grid.Column>
                        <Grid.Column textAlign="center">
                            <CustomImage src="/themes/bakalavr/images/fieb9.jpg?1" centered size="tiny" $margin="0 auto .5em" />
                            серебряные<br /> (<b>следующие 15&nbsp;% студентов</b> в&nbsp;рейтинге)
                        </Grid.Column>
                        <Grid.Column textAlign="center">
                            <CustomImage src="/themes/bakalavr/images/fieb10.jpg?1" centered size="tiny" $margin="0 auto .5em" />
                            бронзовые<br /> (<b>следующие 25&nbsp;% студентов</b> в&nbsp;рейтинге)
                        </Grid.Column>
                        <Grid.Column textAlign="center">
                            <CustomImage src="/themes/bakalavr/images/fieb11.jpg?1" centered size="tiny" $margin="0 auto .5em" />
                            сертификаты участников<br /> (оставшиеся <b>50&nbsp;% студентов</b>)
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <br/>
                <p><b>Именные сертификаты студентов</b> по&nbsp;решению вуза или выпускающей кафедры могут учитываться <Link href="/node/521">при&nbsp;государственной итоговой аттестации</Link>, <Link href="/node/521#magistr">при&nbsp;поступлении в&nbsp;магистратуру</Link>, при&nbsp;трудоустройстве как&nbsp;подтверждение качества подготовки выпускника.</p>
            </Container >
        </FullWidthBackgroundContainer >
        <Container>
            <Segment>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <ThemedText><Link href="/sites/default/files/fieb/otchet_fieb.pdf"><b>Педагогический анализ</b></Link></ThemedText><br />
                            содержит количественные показатели участия студентов в&nbsp;экзамене, информацию о&nbsp;результатах тестирования студентов вуза в&nbsp;сравнении с&nbsp;результатами участников ФИЭБ по&nbsp;аналогичным направлениям подготовки и/или специальностям, анализ уровня сформированности профессиональных компетенций студентов.
                        </Grid.Column>
                        <Grid.Column width={4} verticalAlign='middle'>
                            <Image centered src='/themes/bakalavr/images/fieb13.png' />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        </Container>
        <Container>
            <Grid stackable>
                <Grid.Row>
                    <Grid.Column width={3} verticalAlign="middle">
                        <Image centered src="/themes/tfieb/images/logo.svg" size="small" />
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <p><ThemedText><Link href={'//tfieb.' + drupalHost}><b>«Тренажер ФИЭБ»</b></Link></ThemedText></p>
                        <p>Система целенаправленной тренировки студентов при&nbsp;многократном выполнении заданий, разработанных в&nbsp;соответствии с&nbsp;моделью ПИМ ФИЭБ.</p>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    </BodyContainer>)
}